import { CS } from "../../../../base/utils/styler";

export const rateThStyle: CS = {
    padding: '10px 0',
    textAlign: 'center',
    fontWeight: '900',
    borderBottom: '1px solid gray',

}